// extracted by mini-css-extract-plugin
export default {"root":"modal-paragraph-module__root--sz7Oc"};